/* tslint:disable:indent */
import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {SubSubSubGroup} from '../../model/sub-sub-sub-group';
import {Field} from '../../model/field';
import {EformsSubjectService} from '../../services/eforms-subject.service';
import {StepperBuilderService} from '../../../../avisDePub/creer/services/stepper.builder.service';
import {SubSubSubSubGroup} from '../../model/sub-sub-sub-sub-group';
import {EformDataService} from '../../services/eform-data.service';
import {EformConditionsService} from '../../services/eform-conditions.service';
import { EformDuplicableEntityService } from '../../services/eform-duplicable-entity.service';
import {EformAccordionService} from '../../services/eform-accordion.service';


@Component({
  selector: 'app-sub-sub-sub-group',
  templateUrl: './sub-sub-sub-group.component.html',
  styleUrls: ['../e-forms-generator/e-forms-generator.component.css']
})
export class SubSubSubGroupComponent implements OnInit, AfterViewInit {

  @Input() subSubSubGroup: SubSubSubGroup = {} as SubSubSubGroup;
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() noticeValue: any = {};
  @Output() newSubSubSubGroup = new EventEmitter();
  @Output() deleteSubSubSubGroup = new EventEmitter();
  @Input() repeatablePath: string;
  @Input() repeatablePathWithIndex: string;
  @Input() prefixId: string;
  @Input() subSectionId: string;
  @Input() linkForRouter: string;
  @Input() index: string;
  @Input() getRepeatablePathForDuplicableElementFromParent: () => string;

  repeatablePathForElementDuplicable: string;

  constructor(private stepperBuilderService: StepperBuilderService,
    private eformDuplicableEntityService: EformDuplicableEntityService, private eformsSubjectService: EformsSubjectService, private eformDataService: EformDataService, private eformConditionService: EformConditionsService,
    private eformAccordionService: EformAccordionService) {
  }

  ngOnInit(): void {
    this.repeatablePathForElementDuplicable = this.getRepeatablePathForDuplicableElementFromParent();
  }

  ngAfterViewInit() {
    //Dans le cas de l'edition, on cherche les elements répétable à initialiser
    // 🔧 FIX 2026-02-11: Ne pas créer automatiquement des éléments pour les groupes nouvellement ajoutés manuellement
    const isManuallyAdded = this.subSubSubGroup?.id?.includes('_') && !this.subSubSubGroup?.id?.endsWith('_0');

    let elementToCreate = this.eformConditionService.findElementsToCreate(this.subSubSubGroup, this.repeatablePathWithIndex, this.noticeValue);

    if (elementToCreate?.length && !isManuallyAdded) {
      elementToCreate.forEach(e => {
        this.addSubSubSubGroup();
      });
    }
  }

  newField($event) {
    const field: Field = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.subSubSubGroup.fields.map(gr => gr.id);
    let elementNumber = 1;
    while (ids.includes(field.id.split('_')[0] + '_' + elementNumber)) {
      elementNumber++;
    }
    field.id = field.id.split('_')[0] + '_' + elementNumber;
    const indexToSplice = this.subSubSubGroup.fields.filter(el => el.id.startsWith($event.id)).length
    this.subSubSubGroup.fields.splice((this.subSubSubGroup.fields as any).findIndex(el => el.id === $event.id) + indexToSplice, 0, field);

    this.repeatablePath = field.jsonPath + '_SEPSEP_' + (elementNumber);
    // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici

  }

  deleteField($event: any) {
    this.subSubSubGroup.fields = this.subSubSubGroup.fields.filter(obj => obj !== $event);
    let deletedFieldIndex = +$event.id.split('_')[1];
    //On decale tous supérieurs à celui supprimé les id de 1 pour rester syncro avec les controls
    this.subSubSubGroup.fields.filter(f => f.id.includes('_')).forEach(f => {
      let splittedId = f.id.split('_');
      let actualIndex = +splittedId[1];
      if (actualIndex > deletedFieldIndex) {
        let newIndex = actualIndex - 1;
        f.id = splittedId[0] + '_' + newIndex;
      }
    });
  }

  addSubSubSubGroup() {
    this.newSubSubSubGroup.emit(this.subSubSubGroup);
  }

  removeSubSubSubGroup() {
    this.deleteSubSubSubGroup.emit(this.subSubSubGroup);
  }

  newSubSubSubSubGroup($event: any) {
    const subSubSubSubGroup: SubSubSubSubGroup = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.subSubSubGroup.subSubSubSubGroup.map(gr => gr.id);

    let elementNumber = 1;
    if (subSubSubSubGroup.id.includes("_")) {
      subSubSubSubGroup.repeatedId = subSubSubSubGroup.id.split('_').slice(1).map(Number);
      subSubSubSubGroup.id = subSubSubSubGroup.id.split('_').slice(0, -1).join('_');
    } else {
      subSubSubSubGroup.repeatedId = [0];
    }
    while (ids.includes(subSubSubSubGroup.id + '_' + elementNumber)) {
      elementNumber++;
    }

    subSubSubSubGroup.id = subSubSubSubGroup.id.split('_')[0];
    subSubSubSubGroup.repeatedId.splice(-1, 1, elementNumber);
    subSubSubSubGroup.repeatedId.forEach(id => subSubSubSubGroup.id += '_' + id);

    this.subSubSubGroup.subSubSubSubGroup.push(subSubSubSubGroup);
    this.repeatablePath = subSubSubSubGroup.jsonPath + '_SEPSEP_' + (elementNumber);
    // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici

    this.isDeletable(subSubSubSubGroup.id);
    this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(true);
  }

  deleteSubSubSubSubGroup($event: any) {
    // 🔧 FIX 2026-02-16: On récupère l'index AVANT de modifier la liste
    let indexToDelete = 0;
    if ($event.repeatedId) {
      indexToDelete = $event.repeatedId.slice(-1)[0];
    } else {
      indexToDelete = 0;
    }

    // 🔧 FIX 2026-02-16: Calculer le repeatablePathWithIndex avec l'index explicite AVANT les modifications
    const repeatablePathForDelete = this.getRepeatablePathWithIndexForSubSubSubSubGroupWithExplicitIndex($event, indexToDelete);

    this.subSubSubGroup.subSubSubSubGroup = this.subSubSubGroup.subSubSubSubGroup.filter(obj => obj !== $event);

    this.subSubSubGroup.subSubSubSubGroup.filter(subSubSubSubGroup => subSubSubSubGroup.id.includes($event.id.split("_")[0])).forEach(subSubSubSubGroup => {
      if (subSubSubSubGroup.repeatedId && subSubSubSubGroup.repeatedId.slice(-1)[0] > indexToDelete) {
        subSubSubSubGroup.repeatedId.push(subSubSubSubGroup.repeatedId.pop() - 1);
        subSubSubSubGroup.id = subSubSubSubGroup.id.split("_")[0];
        subSubSubSubGroup.repeatedId.forEach(id => subSubSubSubGroup.id += '_' + id);
      }
      if (!$event.id.includes("_") && subSubSubSubGroup.repeatedId.slice(-1)[0] === 0) {
        subSubSubSubGroup.id = subSubSubSubGroup.id.slice(0, -2);
      }
    });

    //On supprime le groupe du formulaire avec l'index explicite
    let pathElements: Array<string> = $event.jsonPath.split('.');
    pathElements.pop();
    this.formGroup = this.stepperBuilderService.removeLastControl(this.formGroup, pathElements, repeatablePathForDelete, indexToDelete, $event.listname);
    this.isDeletable($event.id);
    this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(true);
  }

  /**
   * 🔧 FIX 2026-02-16: Nouvelle méthode pour calculer le repeatablePathWithIndex avec un index explicite
   */
  private getRepeatablePathWithIndexForSubSubSubSubGroupWithExplicitIndex = (subSubSubSubGroup, explicitIndex: number): string => {
    if (subSubSubSubGroup.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      return pathToReturn + subSubSubSubGroup.jsonPath + '_INDEX_' + explicitIndex;
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathWithIndexForInput = (field): string => {
    if (field.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      // ⚠️ NE PAS modifier repeatablePathForElementDuplicable ici
      return pathToReturn + this.isRepeatableField(field) + field.jsonPath + '_INDEX_' + (this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0');
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathForDuplicableElement = (): string =>{
    return this.repeatablePathForElementDuplicable
  }

  isRepeatableField(field) {
    if (field._repeatable) {
      let tempJsonPath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]') + 2);
      return tempJsonPath + '_INDEX_' + (this.eformDataService.getArray(field, this.formGroup, this.repeatablePathWithIndex, tempJsonPath)) + '_SEPSEP_';
    } else if (field.isJsonPathAlreadyUsed) {
      let tempJsonPath;
      let tmpPath;
      if (this.repeatablePathWithIndex) {
        tmpPath = field?.jsonPath?.replace(this.repeatablePathWithIndex.slice(0, this.repeatablePathWithIndex.indexOf('val')), '');
        let tmpPathArray: any[] = tmpPath.split('.');
        if (tmpPathArray.filter(e => e.includes('[]')).length > 1) {
          tmpPathArray.shift()
          tmpPath = tmpPathArray.join('.');
        }
        if (tmpPath.includes('fieldsprivacy')) {
          tmpPath = tmpPath?.slice(tmpPath.indexOf('fieldsprivacy'), tmpPath?.indexOf('val'));
        }
        tmpPath = tmpPath?.slice(0, tmpPath?.indexOf('[]'));
        tempJsonPath = field.jsonPath.slice(0, field.jsonPath.indexOf(tmpPath) + tmpPath.length);
      } else {
        tempJsonPath = field?.jsonPath?.slice(0, field?.jsonPath?.indexOf('[]'))
      }
      let pathElements = tempJsonPath.split('.');
      let tempControl = this.eformsSubjectService.getField(pathElements, this.formGroup, this.repeatablePathWithIndex);
      let index = 0;
      if (Array.isArray(tempControl?.controls)) {
        let count = 0;
        const pathToCheck = field?.jsonPath?.replaceAll('[]', '').split('.').slice(field?.jsonPath?.replaceAll('[]', '').split('.').indexOf(pathElements[pathElements.length - 1]) + 1, field?.jsonPath?.replaceAll('[]', '').split('.').indexOf('val'));
        if (pathToCheck.length > 1) {
          let i = 0;
          for (const element of tempControl?.controls) {
            if (element.get(pathToCheck[i]) && !Array.isArray(element.get(pathToCheck[i])?.controls)) {
              if (this.checkPathrecursively(element.get(pathToCheck[i]), pathToCheck, i + 1, pathToCheck[pathToCheck.length - 1])) {
                count++
              }
            }
          }
        } else {
          for (const element of tempControl?.controls) {
            if (element.get(pathToCheck[0])) {
              count++
            }
          }
        }

        index = count;
      }
      return tempJsonPath + '[]' + '_INDEX_' + index + '_SEPSEP_';
    } else {
      return '';
    }
  }

  checkPathrecursively(tmpElement, elements, index, lastElement): boolean {
    let isFound = false;
    if (Array.isArray(tmpElement?.controls)) {
      return false;
    } else {
      if (tmpElement?.controls[elements[index]]) {
        if (elements[index] != lastElement) {
          this.checkPathrecursively(tmpElement?.controls[elements[index]], elements, index + 1, lastElement)
        } else {
          return true;
        }
      }
    }
    return isFound;
  }

  getRepeatablePathWithIndexForSubSubSubSubGroup(subSubSubSubGroup, isForDelete?) {
    if (subSubSubSubGroup.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }

      let index = this.eformDataService.getArray(subSubSubSubGroup, this.formGroup, this.repeatablePathWithIndex, undefined, undefined, undefined, undefined, undefined, isForDelete);

      this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, subSubSubSubGroup.jsonPath, Number(index), undefined,isForDelete)
      return pathToReturn + subSubSubSubGroup.jsonPath + '_INDEX_' + (index);
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getIndex(id: string) {
    let element = id.split("_");
    return {value: id.split("_")[element.length - 1], bool: element.length > 1};
  }

  private isDeletable(elementId) {
    let baseId = elementId;
    if (elementId.includes('_')) {
      baseId = elementId.split('_')[0];
    }
    let filteredElements = this.subSubSubGroup.subSubSubSubGroup.filter(el => el.id=== baseId || el.id.includes(baseId+'_'));
    //Si on en a plus d'un le bouton supprimer doit etre dispo sur toutes
    if (filteredElements.length > 1) {
      filteredElements.forEach(s => s.deletable = true);
    } else {
      //Sinon aucun bouton supprimer
      filteredElements.forEach(s => s.deletable = false);
    }
  }

  parcoursUtilisateur(subSubSubGroup){
    return subSubSubGroup.parcoursUtilisateur?.messageInfo;
  }

  /**
   * 🔧 FIX 2026-02-26: Extrait le type de groupe à partir d'un ID
   * Ex: "GR-Lot-AwardCriteria-Criterion_1" -> "GR-Lot-AwardCriteria-Criterion"
   */
  getGroupType(elementId: string): string {
    return this.eformAccordionService.extractGroupType(elementId);
  }
}
